<template>
  <div>
    <CRow>
      <CCol sm="12">
        <RolesTable
          :items="roles"
          :permissions="permissions"
          hover
          striped
          border
          small
          fixed
          caption="Roles y Permisos"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import RolesTable from '../../components/roles/RolesTable.vue'
import roles from '../../services/roles';
import store from '../../store'

export default {
  name: 'Roles',
  components: { RolesTable },
  data: function () {
		return {
            roles: [],
            permissions: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await roles.get();

    if(response.type == "success"){
      this.roles = response.data;
    }

    let response2 = await roles.getPermissions();

    if(response2.type == "success"){
      this.permissions = response2.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.roles = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
